const Style = {

  base: 'max-w-full',
  interactive: 'cursor-pointer',
  preview250x250: 'max-w-xs max-h-80'

}

export default Style;